import { render } from "./EnquiryFormBranchAppointment.vue?vue&type=template&id=706fbfff"
import script from "./EnquiryFormBranchAppointment.vue?vue&type=script&lang=js"
export * from "./EnquiryFormBranchAppointment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__